export const CORN_ICON_URL = 'https://static.rfstat.com/renderforest/images/v2/mockup-images/corn2.png'